import PropTypes from 'prop-types'
import React, { Component } from 'react'

import { isEmpty } from '../../utilities/GeneralUtils'
import { ROLES } from '../../utilities/accessibility/Definitions'
import Cont from '../layout/Cont'
import TextBlock from '../text/TextBlock'

/** This component is used for rating things such as facility, website experience, etc.

@example ../../../../docs/external/form/ARatingSelector.md */

class ARatingSelector extends Component {
  constructor(...args) {
    super(...args)
    this.state = { currSelectedOption: this.props.selectedOption }
  }

  getOptionsUI() {
    const { optionValues, optionLabels, htmlIndicators, label } = this.props
    const getOptionUI = this.getOptionUI.bind(this)
    let optionsUI = null
    optionsUI = optionLabels.map((optionLabel, i) => {
      const optionValue = optionValues[i]
      let isHTML = false
      if (
        typeof htmlIndicators !== 'undefined' &&
        htmlIndicators.length > 0 &&
        typeof htmlIndicators[i] !== 'undefined'
      ) {
        isHTML = htmlIndicators[i]
      }

      return getOptionUI(optionLabel, optionValue, isHTML, i)
    })

    return (
      <Cont
        className={'a-rate-inliner'}
        cmpRole={ROLES.WIDGET.RADIOGROUP}
        cmpLabel={label}
      >
        {optionsUI}
      </Cont>
    )
  }

  getOptionUI(optionLabel, optionValue, isHTML, key) {
    const {
      displayOptionLabels,
      optionStylePrefix,
      optionIconStyle,
      optionIconSelectedStyle,
      cmpRef,
      readOnly,
    } = this.props
    const { currSelectedOption } = this.state
    let labelUI = null
    let iconStyle = optionIconStyle
    let iconSelectedStyle = optionIconSelectedStyle
    let style = ''
    let buttonRef = null
    let isSelected = false

    if (displayOptionLabels) {
      labelUI = (
        <TextBlock className={''} content={optionLabel} isHTML={isHTML} />
      )
    }

    if (optionStylePrefix !== null) {
      iconStyle = optionStylePrefix + optionValue
      iconSelectedStyle = `${optionStylePrefix}selected`
    }

    style = iconStyle
    if (this.isOptionSelected(optionValue)) {
      style += ` ${iconSelectedStyle}`
    }

    if (cmpRef !== null) {
      buttonRef = `${cmpRef}-${key}`
    }

    if (key === currSelectedOption - 1) {
      isSelected = true
    }

    return (
      <div
        key={key}
        data-ref={buttonRef}
        className={`a-rate${readOnly ? ' a-rate--disabled' : ''}`}
        onClick={() => {
          this.onOptionClick(optionValue)
        }}
      >
        <div
          className={style}
          role={ROLES.WIDGET.RADIO}
          aria-checked={isSelected}
          aria-label={optionValue}
        />
        {labelUI}
      </div>
    )
  }

  isOptionSelected(optionValue) {
    const { currSelectedOption } = this.state
    const { rangeSelect, optionValues } = this.props
    let isSelected = false
    if (currSelectedOption === null) {
      return isSelected
    }
    if (currSelectedOption === optionValue) {
      isSelected = true
    }
    if (rangeSelect) {
      let optionIndex = 0
      let currSelectedOptionIndex = 0
      for (let i = 0; i < optionValues.length; i++) {
        if (optionValues[i] === optionValue) {
          optionIndex = i
        }
        if (optionValues[i] === currSelectedOption) {
          currSelectedOptionIndex = i
        }
      }
      if (optionIndex < currSelectedOptionIndex) {
        isSelected = true
      }
    }

    return isSelected
  }

  onOptionClick(optionValue) {
    const { id, onSelect, readOnly } = this.props
    if (readOnly) {
      return false
    }

    this.setState({
      ...this.state,
      currSelectedOption: optionValue,
    })

    return onSelect(id, optionValue)
  }

  render() {
    const { label, help, style, formGroup, cmpRef } = this.props
    const optionsUI = this.getOptionsUI()
    let labelUI = null
    let helpContent = null
    let divWrapper = ''

    if (typeof label !== 'undefined' && !isEmpty(label)) {
      labelUI = (
        <div>
          <label className={'control-label'}>
            <span>{label}</span>
          </label>
        </div>
      )
    }

    if (typeof help !== 'undefined' && !isEmpty(help)) {
      helpContent = <span className={'help-block'}>{help}</span>
    }

    if (typeof style !== 'undefined' && style === 'error') {
      divWrapper = 'has-error'
    }

    return (
      <Cont className={divWrapper} formGroup={formGroup} cmpRef={cmpRef}>
        {labelUI}
        {optionsUI}
        {helpContent}
      </Cont>
    )
  }
}

ARatingSelector.defaultProps = {
  selectedOption: null,
  displayOptionLabels: true,
  rangeSelect: true,
  optionStylePrefix: null,
  optionIconStyle: 'a-rate-option',
  optionIconSelectedStyle: 'a-rate-option-selected',
  formGroup: false,
  cmpRef: null,
  readOnly: false,
}

ARatingSelector.propTypes = {
  id: PropTypes.string.isRequired,
  cmpRef: PropTypes.string,
  label: PropTypes.string.isRequired,
  optionLabels: PropTypes.array.isRequired,
  optionValues: PropTypes.array.isRequired,
  htmlIndicators: PropTypes.array,
  displayOptionLabels: PropTypes.bool,
  selectedOption: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  rangeSelect: PropTypes.bool,
  optionStylePrefix: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  help: PropTypes.array,
  style: PropTypes.string,
  optionIconStyle: PropTypes.string,
  optionIconSelectedStyle: PropTypes.string,
  formGroup: PropTypes.bool,
  readOnly: PropTypes.bool,
}

export default ARatingSelector
